import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=3c4a974e&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=3c4a974e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4a974e",
  null
  
)

export default component.exports